<template>
  <v-container fluid>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar
            dark
            color="primary"
          >
            <v-btn
              icon
              dark
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ lang[$globalData.appLang].dienst }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                v-if="formData.status != 3"
                dark
                text
                @click="saveDialog"
              >
                {{ lang[$globalData.appLang].opslaan }}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-form>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-row class="pa-4 pb-8">
                    <v-col class="pa-0" cols="4">
                      {{ lang[$globalData.appLang].datum }}
                    </v-col>
                    <v-col class="pa-0" cols="8">
                      : {{ formData.formatted_datum }}
                    </v-col>
                  
                    <v-col class="pa-0" cols="4">
                      {{ lang[$globalData.appLang].opdrachtgever }}
                    </v-col>
                    <v-col class="pa-0" cols="8">
                      : {{ formData.naam }}
                    </v-col>
                    
                    <v-col class="pa-0" cols="4">
                      {{ lang[$globalData.appLang].tijd }}
                    </v-col>
                    <v-col class="pa-0" cols="8">
                      : {{ formData.startdienst }} - {{ formData.einddienst }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" class="pa-4 pt-6">
                  {{ lang[$globalData.appLang].werkelijke_tijd }}
                </v-col>
                <v-col
                  cols="6" class="pt-0"
                >
                  <v-text-field
                    v-model="formData.starttijd"
                    :label=lang[$globalData.appLang].starttijd
                    type="time"
                    prepend-icon="mdi-clock-time-four-outline"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6" class="pt-0"
                >
                  <v-text-field
                    v-model="formData.eindtijd"
                    :label=lang[$globalData.appLang].eindtijd
                    type="time"
                    prepend-icon="mdi-clock-time-four-outline"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12" class="pt-0"
                >
                  <v-textarea
                    v-model="formData.werknemer_opmerking"
                    name="input-7-1"
                    rows="2"
                    :label=lang[$globalData.appLang].opmerkingen
                  ></v-textarea>
                </v-col>
                <v-col
                  cols="6" class="pt-0"
                >
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-list two-line>
          <template v-for="(item, index) in assignments">
            <v-list-item
              :key="item.datum"
              :class="{ 'green lighten-4': item.status == 3, 'blue lighten-4': item.ingevuld, 'red lighten-4': item.status == 2 }"
              @click.stop="loadDialog({ opdrachtid : item.opdrachtID, datum: item.datum })"
            >
              <template>
                <v-list-item-content>
                  <v-list-item-title
                    class="primary--text"
                  >
                    {{ item.formatted_datum }}, <span class="text-body-2">{{ item.startdienst }} - {{ item.einddienst }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle
                    class="text--primary"
                  >
                    <v-icon small>mdi-seal</v-icon> {{ item.functie }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle><v-icon small>mdi-domain</v-icon> {{ item.naam }}</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  
                </v-list-item-action>
              </template>
            </v-list-item>

            <v-divider
              v-if="index < assignments.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'HomeView',
    
    data: () => ({
      lang: {
        nl: {
          dienst: 'Dienst',
          opslaan: 'OPSLAAN',
          datum: 'Datum',
          opdrachtgever: 'opdrachtgever',
          tijd: 'Tijd',
          werkelijke_tijd: 'Werkelijk gewerkte tijd',
          starttijd: 'Starttijd',
          eindtijd: 'Eindtijd',
          opmerkingen: 'Opmerkingen',
          vernieuwen: 'vernieuwen'
        },
        en: {
          dienst: 'Shift',
          opslaan: 'SAVE',
          datum: 'Date',
          opdrachtgever: 'customer',
          tijd: 'Hours',
          werkelijke_tijd: 'Actual worked hours',
          starttijd: 'Start time',
          eindtijd: 'End time',
          opmerkingen: 'Comments',
          vernieuwen: 'refresh'
        },
      },
      time: null,
      time2: null,
        starttijdMenu2: false,
        eindtijdMenu2: false,
        modal2: false,
    
      dialog: false,
      selected: [],
      assignments: { 
        planningID: [] 
      },
      formData: []
    }),
    mounted () {
      this.loadData()
    },
    methods: {
      loadData () {
        axios
          .get(process.env.VUE_APP_API_URL + '/app/get_assignments', { params: this.loadOptions })
          .then(response => {
            this.assignments = response.data
          })
          .catch(error => {
            console.log(error)
            this.errorMessage = error
            this.errored = true
          })
      },
      refresh(done) {
        setTimeout(() => {
          this.loadData()
          done()
        }, 1000)
      },
      loadDialog (item) {
        axios
          .get(process.env.VUE_APP_API_URL + '/app/get_assignment_data', { params: item })
          .then(response => {
            this.formData = response.data
          })
          .catch(error => {
            console.log(error)
            this.errorMessage = error
            this.errored = true
          })
        this.dialog = !this.dialog
      },
      saveDialog () {
        axios
          .post(process.env.VUE_APP_API_URL + '/app/save_assignment/', this.formData)
          .then(response => {
            this.assignments = response.data
            this.dialog = false
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
      }
    }
  }
</script>
